import Head from "next/head"
import styles from "@/styles/viewcar.module.scss"
import CheckoutLayout from "@/components/CheckoutLayout"
import {
  Button,
  Row,
  Table,
  Image,
  Select,
  Checkbox,
  Col,
  InputNumber,
  Popover,
  Input,
  message,
  Modal,
  Spin,
  Skeleton,
  ConfigProvider
} from "antd"
import { ExclamationCircleFilled, DownOutlined, LeftOutlined, RightOutlined } from "@ant-design/icons"
import { useEffect, useRef, useState } from "react"
import Link from "next/link.js"
import getConfig from 'next/config'
const { publicRuntimeConfig } = getConfig()
const imageDomain = publicRuntimeConfig.imageDomain
import viewcartApi from '@/service/modules/viewcartApi'
import productApi from '@/service/modules/productApi'
import myAccountApi from '@/service/modules/myAccountApi'
import paymentApi from '@/service/modules/paymentApi'
import featuredSectionApi from '@/service/modules/featuredSectionApi'
import SwiperSelf from "@/components/SwiperSelf"
import { SwiperSlide } from "swiper/react"
import useCartActions from '@/utils/addTocartAction'
import loginApi from "@/service/modules/loginApi"
import { useSelector } from 'react-redux';
import { RootState } from '@/store/store';
import { getCookie } from "@/utils/cookie"

import DeleteHover from '@/svgs/checkout/delete-hover.svg'
import DeleteIcon from '@/svgs/checkout/delete.svg'
import WishListHover from '@/svgs/checkout/My-Wishlist-hover.svg'
import WishListIcon from '@/svgs/checkout/My-Wishlist.svg'
import HoverIconSwitch from "@/components/checkout/HoverIconSwitch"
import { formatCurrency, getCompressedImageUrl } from "@/utils/utils"
import ProgressBar from "@/components/ProgressBar"
import { setGtmDataLayer } from "@/utils/gtmDataLayer"
import SuburbSelect from "@/components/SuburbSelect"
import { updateUserInfo } from "@/store/slices/userInfoSlice"
import { useDispatch } from "react-redux"
import { AppDispatch } from '@/store/store';

import AmericanExpressSvg from '@/svgs/pay/viewcart/American-express.svg'
import VisaSvg from '@/svgs/pay/viewcart/VISA.svg'
import MastercardSvg from '@/svgs/pay/viewcart/Mastercard.svg'
import PaypalSvg from '@/svgs/pay/viewcart/Paypal.svg'
import AfterpaySvg from '@/svgs/pay-icon/afterpay-logo.svg'
import ZipSvg from '@/svgs/pay/viewcart/Zip.svg'
import AfterpayCheckoutSvg from '@/svgs/pay/viewcart/icon-Checkout-afterpay-color.svg'
import PaypalCheckoutSvg from '@/svgs/pay/viewcart/icon-pp-fchl.svg'
import Steps from "@/components/checkout/steps"
interface LoadingRows {
  [key: number]: boolean;
}

// 计算已经没有选中的邮费
let currentBatchID: string | null = null;


export default function Viewcar() {
  const dispatch: AppDispatch = useDispatch();
  const [effectiveList, setEffectiveList] = useState([])
  const [invalidityList, setInvalidity] = useState([])
  const [isFirst, setIsFirst] = useState(true)
  const [showCoupon, setShowCoupon] = useState(false)
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [loading, setLoading] = useState(false)
  const [deleteLoading, setDeleteLoading] = useState(false)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [deleteArray, setDeleteArray] = useState<React.Key[]>([])
  // const [wishListArray, setWishListArray] = useState<React.Key[]>([])
  const [loadingRows, setLoadingRows] = useState<LoadingRows>({});

  const defaultSuburbID = useSelector((state: RootState) => state.userInfo.data.suburbID);
  const defaultSuburbName = useSelector((state: RootState) => state.userInfo.data.suburb);
  const [suburbId, setSuburbId] = useState<any>("")
  const [suburbName, setSuburbName] = useState<string>("")
  const [inputFocus, setInputFocus] = useState(false)

  const [credits, setCredits] = useState(0)
  const [points, setPoints] = useState(0)
  const [topsaleList, setTopsaleList] = useState([])
  const [creditsInput, setCreditsInput]: any = useState(0)
  const [pointsInput, setPointsInput]: any = useState(0)
  const [coupon, setCoupon]: any = useState()
  const [applyBtnLoading, setApplyBtnLoading] = useState(false)
  const [paymentInfo, setPaymentInfo] = useState<any>({})
  const [discountInfo, setDiscountInfo] = useState<any>({})
  const [isLogin, setIsLogin] = useState(false)
  const [affiliateid, setAffiliateid] = useState<string | undefined>("")
  // 配置一个Uleeid 用于判断 不可用场景
  const [isUleeId, setIsUleeId] = useState(false)
  const [couponPackage, setCouponPackage] = useState<number>(0)
  const [packagesList, setPackagesList] = useState<any>([])

  const [afterPayJs, setAfterPayJs] = useState('')
  const [afterPayJsLoaded, setAfterPayJsLoaded] = useState(false)
  const [paymentLoading, setPaymentLoading] = useState(false)
  const [showSaveCart, setShowSaveCart] = useState(false)
  const [compareLoading, setCompareLoading] = useState(false)
  const customerID = useSelector((state: RootState) => state.userInfo.data.customerID);
  const [selectNum, setSelectNum] = useState(0)

  useEffect(() => {
    // 初始化读取cookie中的affiliateid值
    const initialAffiliateId = getCookie('affiliateid');
    setAffiliateid(initialAffiliateId);
    setIsUleeId(affiliateid == '23' ||
      affiliateid == '1002' ||
      affiliateid == '1' ||
      affiliateid == '19' ||
      affiliateid == '21')
    // 定期检查cookie中的affiliateid值的变化
    const checkCookie = setInterval(() => {
      const currentAffiliateId = getCookie('affiliateid');
      if (currentAffiliateId !== affiliateid) {
        setAffiliateid(currentAffiliateId);
      }
    }, 1000); // 每秒检查一次
    // 清理定时器
    return () => clearInterval(checkCookie);
  }, [affiliateid])



  useEffect(() => {
    checkIsLogin()
  }, [])

  useEffect(() => {
    if (defaultSuburbID) {
      setSuburbId(parseInt(`${defaultSuburbID}`))
      setSuburbName(defaultSuburbName)
    }
  }, [defaultSuburbID])

  useEffect(() => {
    if (suburbId) {
      getList()
    }
  }, [suburbId])

  // 监听添加购物车成功事件
  // useEffect(() => {
  //   window.addEventListener('updateCart', successAddCart);
  //   return () => {
  //     window.removeEventListener('updateCart', successAddCart);
  //   };
  // }, [])

  const getList = async () => {
    !loading && setLoading(true)
    try {
      const res = await viewcartApi.getList()
      setLoading(false)
      setIsFirst(false)
      // if (!res.data.subtotal) {
      //   setEffectiveList([])
      //   setInvalidity([])
      //   return
      // }
      setPageDate(res)

      // 等待列表数据, 推送到Emarsys
      if (res.data && res.data.list && res.data.list.available) {
        pushScarabQueueEvent(res.data.list.available || [])
      }
    } catch (error: any) {
      message.error(error.message)
      setLoading(false)
      setIsFirst(false)
    }
  }

  const setPageDate = async (res: any) => {
    const { data: { list: { available, unavailable }, count } } = res
    let loadRows: LoadingRows = {}
    let rowKeys: Array<number> = []
    let unSelectList: Array<any> = []
    const batchID = generateRandomID();
    currentBatchID = batchID;

    setSelectNum(count)
    if (available && available.length) {
      setEffectiveList(available)
      available.forEach((v: any) => {
        // 给所有有效列表的行加上邮费 loading状态
        loadRows[v.productID] = true

        // 过滤出选中列表
        if (v.appSelectStatus == 1) {
          rowKeys.push(v.productID)
        } else {
          // 过滤出未选中的列表
          unSelectList.push(v)
        }
      })
    } else {
      setEffectiveList([])
    }
    if (unavailable && unavailable.length) {
      setInvalidity(unavailable)
    } else {
      setInvalidity([])
    }
    setSelectedRowKeys(rowKeys)


    setLoadingRows(loadRows)

    // 计算已经选中的邮费，算完后马上计算没有选中的邮费
    if (rowKeys.length) {
      // const loginStatus = isFirst ? await checkIsLogin() : false;
      if (customerID) {
        await getCouponsList();
      } else {
        await calculateSelectPost();
      }
    } else {
      setPaymentInfo({})
      setDiscountInfo({})
      setPackagesList([])
      setCouponPackage(0)
      setCoupon("")
      setShowSaveCart(false)
    }
    if (unSelectList.length) {
      calculateUnSelectPost(unSelectList, batchID)
    }
  }

  // 计算已经选中的邮费
  const calculateSelectPost = async () => {
    try {
      const res = await viewcartApi.calculateSelectPost({ suburb: suburbName, suburbID: suburbId })
      setCalculateData(res)
      const { data: { cart } } = res
      if (cart.discountInfo && cart.discountInfo.message) {
        // message.error(cart.discountInfo.message)
        setCouponPackage(0)
        setCoupon("")
      }
    } catch (error: any) {
      if (error.message) {
        message.error(error.message)
      }
    }
  }

  const setCalculateData = (response: any) => {
    const { data: { cart: { items }, cart } } = response
    if (!(cart && items)) return
    setPostTable(items);
    setPaymentInfo(cart)
    setShowSaveCart(cart.totalSave && cart.totalSave > 0)

    if (cart.discountInfo && cart.discountInfo.discountTotal) {
      setDiscountInfo(cart.discountInfo || {})
      setShowCoupon(true)
    } else {
      setDiscountInfo({})
    }

    if (cart.discountInfo && cart.discountInfo.points) {
      setPointsInput(cart.discountInfo.points)
    } else {
      setPointsInput(0)
    }

    if (cart.discountInfo && cart.discountInfo.credits) {
      setCreditsInput(cart.discountInfo.credits)
    } else {
      setCreditsInput(0)
    }

    if (cart.discountInfo && cart.discountInfo.packageID > 0) {
      setCouponPackage(cart.discountInfo.packageID)
    } else {
      setCouponPackage(0)
    }

    // 设置 Tag Assistant Legacy data

    let ecomm_prodid = []
    for (const key in items) {
      if (Object.prototype.hasOwnProperty.call(items, key)) {
        const element = items[key];
        ecomm_prodid.push(element.productID)
      }
    }
    const porductId = ecomm_prodid.join(",")
    const g_params = {
      "remarketing_params": {
        "ecomm_prodid": ecomm_prodid,
        "ecomm_pagetype": "cart",
        "ecomm_totalvalue": cart.subTotal - cart.discount,
        "ecomm_prodname": "",
        "ecomm_catname": "",
        "ecomm_email": ""
      },
      "params": {
        "userId": customerID,
        "categoryId": null,
        "productId": porductId
      }
    }

    setGtmDataLayer(g_params)

    console.log(cart, ' === cart');
  }

  const generateRandomID = () => {
    return Math.random().toString(36).substr(2, 9);
  };

  const calculateUnSelectPost = async (unavailableList: Array<any>, batchID: any) => {
    if (unavailableList.length === 0) return;

    const selectNum = 10;

    const processBatch = async (batch: Array<any>, batchID: string) => {
      if (batchID !== currentBatchID) {
        // If the batch ID does not match the current batch ID, exit the function
        return;
      }

      const firstTen = batch.map((v: any) => ({
        productID: v.productID,
        quantity: v.quantity
      }));

      const params = {
        suburb: suburbName,
        items: firstTen,
        suburbID: suburbId
      };

      try {
        const res = await viewcartApi.calcSingle(params);
        const { data: { cart: { items } } } = res;
        setPostTable(items);
      } catch (error: any) {
        message.error(error.message);
      }
    };

    const batches = [];

    while (unavailableList.length) {
      batches.push(unavailableList.splice(0, selectNum));
    }

    for (const batch of batches) {
      await processBatch(batch, batchID);
    }
  };


  // 写回真实邮费到table中
  const setPostTable = (postItems: any) => {
    let map: any = postItems
    let newLoadRows: LoadingRows = {};
    for (const key in postItems as Record<number, any>) {
      if (Object.prototype.hasOwnProperty.call(postItems, key)) {
        newLoadRows[key] = false
      }
    }

    // 写回到 table中
    setEffectiveList((invalidity: any) => (
      invalidity.map((item: any) => ({
        ...item,
        ...map[item.productID]
      }))
    ))
    setLoadingRows((loadRows: LoadingRows) => ({ ...loadRows, ...newLoadRows }))
  }

  // 更新购物车列表
  const successAddCart = (res: any) => {
    setPageDate(res)
  }

  const applyDiscount = async () => {
    try {
      if (selectedRowKeys.length < 1) {
        message.error('Please select items！')
        return
      }
      if (couponPackage < 1 && !coupon && pointsInput < 0 && creditsInput < 0) {
        message.error('Please use your credits, CrazysPoints, or coupon code to apply the discount.')
        return
      }
      setApplyBtnLoading(true)
      const params = {
        "coupon": couponPackage > 0 ? '' : coupon,
        "credits": creditsInput ? creditsInput : 0,
        "points": pointsInput ? pointsInput : 0,
        "suburbID": suburbId,
        "suburb": suburbName,
        'packageID': couponPackage > 0 ? couponPackage : 0
      }
      const res = await viewcartApi.applyDiscount(params)
      setApplyBtnLoading(false)
      setCalculateData(res)
      const { data: { cart } } = res
      if (cart.discountInfo && cart.discountInfo.message) {
        message.error(cart.discountInfo.message)
        setCouponPackage(0)
        setCoupon("")
      }
    } catch (error: any) {
      message.error(error.message)
      setApplyBtnLoading(false)
    }
  }

  // 用于第一次加载页面时，使用优惠券
  const usedCoupon = async ({ id }: any) => {
    const params = {
      "coupon": '',
      "credits": 0,
      "points": 0,
      "suburb": suburbName,
      'packageID': id
    }
    const res = await viewcartApi.applyDiscount(params)
    const { data: { cart } } = res
    setApplyBtnLoading(false)
    setCalculateData(res)


    if (cart.discountInfo && cart.discountInfo.message) {
      message.error(cart.discountInfo.message)
      setCouponPackage(0)
      setCoupon("")
    }
  }

  const compareCart = async () => {
    try {
      if (compareLoading) return false
      setCompareLoading(true)
      const invalidity = effectiveList.filter((v: any) => v.appSelectStatus == 1).map((v: any) => ({
        "pid": v.productID,
        "qty": v.quantity,
        "upgrade": v.upgradeExpress,
        "selected": v.appSelectStatus
      }))
      const diffData = await viewcartApi.compareCart({ items: invalidity })
      setCompareLoading(false)
      const { data: { isSame } } = diffData
      if (!isSame) {
        // setLoading(true)
        updataCartList()
        throw new Error("Your shopping cart has been updated due to changes made in another tab. The page will refresh to reflect the latest data.")
      }
      return isSame
    } catch (error: any) {
      setCompareLoading(false)
    }
  }

  // 快速本地更新购物车
  const updateData = (productID: any, newData: any) => {
    const updatedData: any = effectiveList.map((item: any) => {
      if (item.productID === productID) {
        return { ...item, ...newData };
      }
      return item;
    });
    setEffectiveList(updatedData);
  };


  // 更新购物车列表
  const updataCartList = async () => {
    if (suburbId) {
      getList()
    }
  }

  // 更新购物车（数量、upgrade、select）
  const updateCart = async (type: string | number, value: any, items: any) => {
    try {
      if (loading) return false
      const { productID, appSelectStatus, upgradeExpress, quantity } = items
      // 快速更新购物车数据
      switch (type) {
        case "qty":
          updateData(items.productID, { quantity: value })
          break;
        case "upgrade":
          updateData(items.productID, { upgradeExpress: value ? 1 : 0 })
          break;
        case "selected":
          setSelectedRowKeys((prev: any) => value ? [...prev, productID] : prev.filter((item: any) => item !== productID))
          break
      }

      const isSame = await compareCart()
      if (!isSame) return
      setLoading(true)

      let record = {
        "pid": productID,
        "qty": quantity,
        "upgrade": upgradeExpress,
        "selected": appSelectStatus
      }

      switch (type) {
        case "qty":
          record.qty = parseInt(value)
          break;
        case "upgrade":
          record.upgrade = value ? 1 : 0
          break;
        case "selected":
          record.selected = value ? 1 : 0
          break;
      }
      const res: any = await viewcartApi.updateCart(record)
      setLoading(false)
      updataCartList()

    } catch (error: any) {
      setLoading(false)
      if (error.message) {
        message.error(error.message)
      }
    }
  }

  // 批量删除购物车点击
  const betchDelete = (selectedRowKeys: any) => {
    if (selectedRowKeys.length === 0) {
      message.warning("Please select items!")
      return
    }
    setDeleteArray(selectedRowKeys)
    setIsModalOpen(true)
  }

  // 删除购物车,批量删除
  const deleteCart = async () => {
    try {
      setDeleteLoading(true)
      const isSame = await compareCart()
      if (!isSame) return

      await viewcartApi.deleteCart({ pids: deleteArray })
      setIsModalOpen(false)
      setDeleteLoading(false)
      message.success("Successfully!")
      updataCartList()
    } catch (error: any) {
      setIsModalOpen(false)
      setDeleteLoading(false)
      if (error.message) {
        message.error(error.message)
      }
    }
  }

  // 添加心愿单，批量添加
  const addWishlist = async (wishListArray: React.Key[]) => {
    try {
      const isSame = await compareCart()
      if (!isSame) return
      await myAccountApi.wishlistBatchAdd({ pids: wishListArray })
      await viewcartApi.deleteCart({ pids: wishListArray })
      message.success("Successfully!")
      updataCartList()

    } catch (error: any) {
      if (error.message) {
        message.error(error.message)
      }
    }
  }

  // 批量添加心愿单
  const betchAddWishlist = () => {
    if (selectedRowKeys.length === 0) {
      message.warning("Please select items!")
      return
    }
    addWishlist(selectedRowKeys)
  }

  // 批量添加所有无效列表心愿单
  const betchAddWishunAvailablelist = () => {
    addWishlist(invalidityList.map((v: any) => v.productID))
  }

  // 批量删除所有无效列表心愿单
  const betchDeleteAvailablelist = () => {
    setDeleteArray(invalidityList.map((v: any) => v.productID))
    setIsModalOpen(true)
  }

  // 下拉框选择
  const qtyChange = (record: any, value: string | number) => {
    const numValue = typeof value === 'string' ? parseInt(value) : value;
    if (numValue > 0) {
      updateCart("qty", value, record)
    } else {
      // 删除
      // deleteCart()
      setDeleteArray([record.productID])
      setIsModalOpen(true)
    }

  }

  // 单独删除
  const deleteItem = (record: any) => {
    setDeleteArray([record.productID])
    setIsModalOpen(true)
  }

  // 单独加心愿单
  const wishlistItem = (record: any) => {
    addWishlist([record.productID])
  }

  // 单独express
  const expressChange = (record: any, event: any) => {
    updateCart("upgrade", event.target.checked, record)
  }

  const setColumns: any = ({ disabled }: any) => {

    const nameTd = {
      width: "380px",
      title: 'Select all items',
      dataIndex: 'productName',
      render: (name: any, record: any, index: any) => (
        <div className={`${styles['goods-box']}`}>
          <Link
            href={record.url}
            legacyBehavior
          >
            <a rel="noopener noreferrer" className={`${styles['goodsImg']} ${disabled && styles['disabled']}`}>
              <Image
                src={getCompressedImageUrl(record.defaultFullUrl, 112)}
                width="100%"
                height="100%"
                preview={false}
              />
            </a>
          </Link>
          <div className={styles['goodsInfo']}>
            <Link
              href={record.url}
              legacyBehavior
            >
              <a rel="noopener noreferrer" className={styles['name']}>{name}</a>
            </Link>
            <div className={styles['pid']}>PID: {record.productID}</div>
          </div>
        </div>
      )
    }

    const quantityTd = {
      title: 'Quantity',
      dataIndex: 'quantity',
      align: "center",
      width: "130px",
      render: (qty: string, record: any) => (
        <MySelect disabled={disabled} quantity={disabled ? 1 : parseInt(qty)} maxNumber={parseInt(record.inStock > 100 ? 100 : record.inStock)} moreThen={record.inStock > 100} qtyChange={qtyChange.bind(qty, record)} />
      )
    }

    const priceTd = {
      title: 'Unit Price',
      dataIndex: 'price',
      align: "center",
      render: (price: string | number) => (
        <>{formatCurrency(price)}</>
      )
    }

    const expressTd = {
      width: "170px",
      title: 'Express',
      dataIndex: 'upgrade_express',
      align: "center",
      render: (upgrade_express: string | number, record: any) => (
        disabled ? (
          <>-</>
        ) : (record.appSelectStatus == 1 && record.isShowUpgrade == 1)
          ?
          <Row justify="center" align="middle" wrap={true} style={{ textAlign: "center" }}>
            <Col span={24}>
              <Checkbox checked={record.upgradeExpress == 1} onChange={expressChange.bind(upgrade_express, record)}></Checkbox>
            </Col>
            <Col span={24}>
              <div>upgrade to<br />express post</div>
            </Col>
          </Row>
          :
          <>-</>
      )
    }

    const postageTd = {
      width: "145px",
      title: 'Postage',
      dataIndex: 'postage',
      align: "center",
      render: (postage: string | number, record: any) => (
        disabled ? (
          <>-</>
        ) :
          loadingRows[record.productID] ? (
            // 加载中
            <>loading</>
          ) :
            record.savePostage > 0 ? (
              <>
                <div>
                  <span className={styles['postage-price']}>{formatCurrency(postage)}</span>
                  <span className={styles['postage-cross-price']}>{formatCurrency(record.normalPostage)}</span>
                </div>
                <div className={styles['postage-save-price']}>Save: {formatCurrency(record.savePostage)}</div>
              </>

            ) : (
              <> {postage == -1 ? <span style={{ color: "#e6415f" }}>Out of delivery, please try another suburb.</span> : `${formatCurrency(postage)}`}</>
            )

      )
    }

    const subtotalTd = {
      title: 'Item Total',
      dataIndex: 'itemTotal',
      align: "center",
      render: (itemTotal: string | number, record: any) => (
        disabled ? (
          <>-</>
        ) :
          loadingRows[record.productID] ? (
            // 加载中
            // <Spin />
            <>loading</>
          ) : (
            <strong>{formatCurrency(parseFloat(`${itemTotal}`).toFixed(2))}</strong>
          )
      )
    }

    const configTd = {
      width: "120px",
      title: '',
      dataIndex: 'productID',
      render: (productID: any, record: any, index: any) => {

        return (
          <>
            <HoverIconSwitch
              IconOne={<DeleteIcon className={styles['cart-icon']} onClick={deleteItem.bind(productID, record)} />}
              IconTwo={<DeleteHover className={styles['cart-icon']} onClick={deleteItem.bind(productID, record)} />}
              hoverContent="Delete"
            />
            <HoverIconSwitch
              IconOne={<WishListIcon className={styles['cart-icon']} onClick={wishlistItem.bind(productID, record)} />}
              IconTwo={<WishListHover className={styles['cart-icon']} onClick={wishlistItem.bind(productID, record)} />}
              hoverContent="Move to wishlist"
            />
          </>
        )
      }
    }

    return [
      nameTd,
      quantityTd,
      priceTd,
      // expressTd,
      postageTd,
      subtotalTd,
      configTd
    ]

  }

  const onSelect = (record: any, selected: boolean) => {
    updateCart("selected", selected, record)
  };

  const onSelectAll = async (selected: boolean) => {
    try {
      setLoading(true)
      // 全选反选可以不用对比
      // await compareCart()
      await viewcartApi.selectAll({ selected: selected ? 1 : 0 })
      updataCartList()
    } catch (error: any) {
      if (error.message) {
        message.error(error.message)
      }
      setLoading(false)
    }

  }

  const rowSelection: any = {
    selectedRowKeys,
    onSelect: onSelect,
    onSelectAll: onSelectAll
  };

  const paymentLogoList = [
    {
      component: <VisaSvg />
    },
    {
      component: <MastercardSvg />
    },
    {
      component: <PaypalSvg />
    },
    {
      component: <AfterpaySvg />
    },
    {
      component: <ZipSvg />
    },
    {
      component: <img 
        src="https://img.bestdeals.co.nz/images/next/images/svg/pay-icon/Applepay.svg" 
        alt="apple-pay" 
        width={54} 
        height={33}
        style={{ objectFit: 'cover' }}
      />
    },
    {
      component: <img 
        src="https://img.bestdeals.co.nz/images/next/images/svg/pay-icon/google-pay.svg" 
        alt="google-pay" 
        width={54} 
        height={33}
        style={{ objectFit: 'cover' }}
      />
    }
  ]
  const paymentLogoItem = <Row align="middle">
    {
      paymentLogoList.map((item: any, index: number) =>
        <div className={styles['paymentLogoItem']} key={index} style={{ width: 60 }}>
          {item.component}
        </div>
      )
    }
  </Row>

  const slectCoupons = async (couponPackageId: number, option: any) => {
    setCouponPackage(couponPackageId)
  }

  const couponInputChange = (value: string) => {
    setCoupon(value)
    setCouponPackage(0)
    // const hasCoupons = packagesList.find((item: any) => item.name === value)
    // if (hasCoupons) {
    //   setCouponPackage(hasCoupons.id)
    // } else {
    //   setCouponPackage(0)
    // }
  }

  const getCreditsList = async () => {
    try {
      let res = await myAccountApi.creditsList()
      if (res.data) {
        const { credits: { credits, points } } = res.data
        setCredits(credits)
        setPoints(points)
      }
    } catch (error) {
      console.error(error)
    }
  }

  const getTopsaleList = async () => {
    try {
      const res = await featuredSectionApi.mooncakeBox("top-seller")
      const { data } = res
      setTopsaleList(data.splice(0, 3))

    } catch (error) {
      console.log(error);
    }
  }

  const getCouponsList = async () => {
    try {
      const res = await myAccountApi.getCouponsList()
      if (res.data) {
        const { packages } = res.data
        setPackagesList(packages)
        if (packages.length > 0) {
          // 使用券包获取金额
          usedCoupon(packages[0])
          setCouponPackage(packages[0].id)
        } else {
          // 计算选中的商品
          calculateSelectPost()
        }
      }
    } catch (error: any) {
      console.log(error);
    }
  }

  useEffect(() => {
    if (couponPackage > 0 && packagesList.length > 0) {
      const hasCoupons = packagesList.find((item: any) => item.id === couponPackage)
      if (hasCoupons) {
        setCoupon(hasCoupons.name)
      }
    }
  }, [couponPackage, packagesList])

  useEffect(() => {
    getTopsaleList()
  }, [])

  useEffect(() => {
    if (isLogin) {
      getCreditsList()
    }
  }, [isLogin])

  // 注入Emarsys代码
  const RECOMMENDER_SUBDOMAIN = 'https://recommender.scarabresearch.com/js/1CBC47CFE1C81625/scarab-v2.js';
  const CDN_SUBDOMAIN = 'http://cdn.scarabresearch.com/js/1CBC47CFE1C81625/scarab-v2.js';

  // 推送到scarabQueue事件
  function pushScarabQueueEvent(cartList: any) {
    if (window && (window as any).ScarabQueue) {
      if (localStorage.getItem('userEmail')) {
        (window as any).ScarabQueue.push(['setEmail', localStorage.getItem('userEmail')]);
      }

      var scarabQueueCartData = cartList.map(function (item: any) {
        return {
          item: item.productID,
          price: Number(item.price),
          quantity: Number(item.quantity)
        };
      });

      (window as any).ScarabQueue.push(['cart', scarabQueueCartData]);
      (window as any).ScarabQueue.push(['go']);
    } else {
      console.log('no window.ScarabQueue');
    }
  }

  useEffect(() => {
    const subdomain = document.location.protocol === 'https:' ? RECOMMENDER_SUBDOMAIN : CDN_SUBDOMAIN;
    const id = 'scarab-js-api';

    if (document.getElementById(id)) return;

    const js = document.createElement('script');
    js.id = id;
    js.src = subdomain;

    const fs = document.getElementsByTagName('script')[0];
    fs?.parentNode?.insertBefore(js, fs);

    js.onload = () => {
      if (effectiveList && effectiveList.length) pushScarabQueueEvent(effectiveList)
    }

    return () => {
      js.remove();
    };
  }, []);

  // 接口获取afterpay-express-js的url
  useEffect(() => {
    const fetchAfterpayScriptUrl = async () => {
      try {
        const res = await paymentApi.getAfterPayExpressJs()
        if (res.data) setAfterPayJs(res.data.jsUrl)
      } catch (error) {
        console.error('Failed to fetch script URL:', error);
      }
    };

    fetchAfterpayScriptUrl();
  }, []);

  // 注入afterpay-express-js
  useEffect(() => {
    if (afterPayJs) {
      const script = document.createElement('script');
      script.src = afterPayJs;
      script.async = true;
      script.onload = () => {
        setAfterPayJsLoaded(true)
        console.log(`Script loaded successfully: ${afterPayJs}`);
      };
      script.onerror = () => {
        console.error(`Failed to load script: ${afterPayJs}`);
      };

      document.body.appendChild(script);

      return () => {
        document.body.removeChild(script);
      };
    }
  }, [afterPayJs]);

  // 价格变化，重新初始化afterpay-express
  useEffect(() => {
    if (afterPayJsLoaded && paymentInfo && paymentInfo.total > 0 && paymentInfo.total < 4000) {
      handleInitAfterpay()
    }
  }, [afterPayJsLoaded, paymentInfo]);

  // 初始化afterpay-express
  const handleInitAfterpay = async () => {
    console.log(paymentInfo, ' === handleInitAfterpay');

    if (typeof (window as any).AfterPay == 'undefined') {
      console.log('can not use afterpay')
      return
    }

    (window as any).AfterPay.initializeForPopup({
      countryCode: 'AU',
      target: '#afterpayBtn',
      shippingOptionRequired: true,
      buyNow: true,
      onCommenceCheckout: async function (actions: any) {
        try {
          const res = await paymentApi.getAfterPayExpressToken()
          if (res.data && res.data.express) {
            actions.resolve(res.data.express.token)
          }
        } catch (error) {
          console.error('Failed to fetch script URL:', error);
        }
      },
      onComplete: async function (completeData: any) {
        /* handle success/failure of checkout */
        console.log(completeData, ' === onComplete data token');

        if (completeData.data.status == "SUCCESS") {
          try {
            // 设置loading状态，以及loading样式
            setPaymentLoading(true)
            setTimeout(() => {
              handleSpinPosition()
            }, 400);

            const res = await paymentApi.afterpayExpressCapture({
              token: completeData.data.orderToken
            })
            console.log(res, ' === afterpayExpressCapture response');

            if (res.data && res.data.link) {
              // 排除code 194012，194015，194018 因为金额变化的错误，不要提示
              if (
                res.data.code != 194012
                && res.data.code != 194015
                && res.data.code != 194018
                && res.data.message
              ) message.error(res.data.message)

              setTimeout(() => {
                window.location.href = res.data.link
              }, 200);
            } else if (res.data && res.data.orderID) {
              window.location.href = `/PaymentResult/index/${res.data.orderID}?paymentMethod=AFPE`
            } else {
              setPaymentLoading(false)
              if (res.data.message) message.error(res.data.message)
            }
          } catch (error) {
            setPaymentLoading(false)
            message.error('Afterpay Express Capture failed, Please try again')
          }
        } else if (completeData.data.status != "SUCCESS" && completeData.data.status != "CANCELLED") {
          setPaymentLoading(false)
          message.error('Afterpay Express Capture failed, Please try again')
        }
      },
      onShippingAddressChange: function (data: any, actions: any) {
        let shippingAddressInfo = {
          id: '1',
          name: 'Standard Delivery',
          description: 'Provided by BestDeals',
          shippingAmount: { amount: paymentInfo.shipping.toFixed(2).toString(), currency: 'NZD' },
          taxAmount: { amount: paymentInfo.gst.toString(), currency: 'NZD' },
          orderAmount: { amount: paymentInfo.total.toString(), currency: 'NZD' },
        }

        console.log(shippingAddressInfo, ' === shippingAddressInfo');
        actions.resolve([shippingAddressInfo])
      }
    })
  }

  // 调整spin位置
  const handleSpinPosition = () => {
    const element = document.getElementById('payment-select');

    if (element) {
      const rect = element.getBoundingClientRect();
      const calculatedDistanceFromTop = rect.top + window.scrollY - 400;

      // 获取 .ant-spin-wrapper 元素
      const antSpinWrapperElement = document.querySelector('.ant-spin-wrapper') as HTMLElement;
      if (antSpinWrapperElement) {
        // 在 antSpinWrapperElement 内查找任意层级的 .ant-spin 元素
        const antSpinElement = antSpinWrapperElement.querySelector('.ant-spin') as HTMLElement;
        if (antSpinElement) {
          // 设置 .ant-spin 元素的 top 样式
          antSpinElement.style.top = `${calculatedDistanceFromTop}px`; // 修改 top 值
          console.log('Top value set for .ant-spin:', calculatedDistanceFromTop);
        }
      }
    }
  }

  // 唤起paypal express
  const handleOpenPaypal = async () => {
    try {
      if (!selectedRowKeys.length || paymentInfo.total <= 0) {
        message.error('Please select items!')
        return
      }

      const res = await paymentApi.getPaypalExpressUrl()
      if (res.data && res.data.link) {
        window.location.href = res.data.link
      } else {
        if (res.data.message) message.error(res.data.message)
      }
    } catch (error) {
      console.error('Failed to fetch Paypal URL:', error);
    }
  }

  // 先粗略判断是否登录
  const checkIsLogin = async () => {
    try {
      const res = await loginApi.me()
      setIsLogin(!!res.data.customerID)
      dispatch(updateUserInfo(res.data))
      return !!res.data.customerID
    } catch (error) {
      return false
    }
  }

  // checkout点击
  const checkoutEvent = (callBack?: Function) => {
    if (!selectedRowKeys.length) {
      message.error('Please select items!')
      return
    }
    callBack && callBack()
  }

  const suburbChange = (data: any, option: any) => {
    setSuburbId(data)
    option.name && setSuburbName(option.name)
  }

  // Save Cart ele
  const saveCartEle = <div className={styles['save-cart']}>
    <div className={styles['save-cart-title']}>You Save {formatCurrency(paymentInfo.totalSave)} Today!</div>
    <div className={styles['save-cart-content']}>Check out now before these deals expire!</div>
  </div>

  return (
    <>
      <Head>
        <title>Online Shopping in New Zealand: Discount Store - BestDeals.co.nz</title>

        <meta name="keywords" content="" />
        <meta name="description" content="BestDeals.co.nz - New Zealand&#039;s #1 online shopping website! Cheap bargains &amp; discounts with the top online shopping New Zealand store! From furniture, to toys &amp; hobbies, to appliances &amp; pet supplies -- we&#039;ve got it all, with free shipping on selected items!" />
        <meta name="geo.placename" content="New Zealand" />
        <meta name="geo.position" content="-25.274398;133.775136" />
        <meta name="ICBM" content="-25.274398, 133.775136" />
        <meta name="viewport" content="width=1100, initial-scale=0.75" />
      </Head>
      <CheckoutLayout>
        <Spin spinning={paymentLoading} wrapperClassName={'ant-spin-wrapper'}>

          <div className={styles['main']}>
            <div className={styles['viewcar']}>
              {/* 步进器 */}
              <Steps value={0} />

              <ProgressBar isAnimating={loading} />
              {
                // 先展示骨架屏
                isFirst ? <Skeleton loading active paragraph={{ rows: 16 }} />
                  :
                  (effectiveList.length > 0 || invalidityList.length > 0)
                    ?
                    <div className={styles["shopping-cart"]}>
                      <Row align="middle" justify="space-between">
                        <div className={styles['table-title']}>Your Shopping Cart</div>
                        <div>
                          <Button href="/" type="primary" ghost style={{ fontWeight: 'bold' }}>Continue Shopping</Button>
                          <Button onClick={() => { checkoutEvent(() => { window.location.href = '/checkout' }) }} type="primary" style={{ marginLeft: '8px', fontWeight: 'bold' }}>Checkout</Button>
                        </div>
                      </Row>

                      <div className={styles['batch-box']}>
                        <div className={styles['selected']}><span style={{ color: "#e6415f", fontWeight: 'bold' }}>{selectNum}</span>&nbsp;items&nbsp;selected</div>

                        <HoverIconSwitch
                          IconOne={<DeleteIcon className={styles['cart-icon']} onClick={() => { betchDelete(selectedRowKeys); }} />}
                          IconTwo={<DeleteHover className={styles['cart-icon']} onClick={() => { betchDelete(selectedRowKeys); }} />}
                          hoverContent="Delete"
                        />
                        <HoverIconSwitch
                          IconOne={<WishListIcon className={styles['cart-icon']} onClick={betchAddWishlist} />}
                          IconTwo={<WishListHover className={styles['cart-icon']} onClick={betchAddWishlist} />}
                          hoverContent="Move to wishlist"
                        />
                      </div>
                      <div className={styles['table-box']}>
                        <ConfigProvider
                          theme={{
                            components: {
                              Table: {
                                controlItemBgActiveHover: "#fafafa",
                                controlItemBgActive: "#fff",
                              }
                            }
                          }}
                        >
                          <Table
                            dataSource={effectiveList}
                            rowKey="productID"
                            columns={setColumns({ disabled: false })}
                            rowClassName={(record: any) => (!record.savePostage && record.postage == -1 ? styles['highlight-row'] : "")}
                            rowSelection={rowSelection}
                            // loading={loading}
                            pagination={false}
                          />
                        </ConfigProvider>
                      </div>

                      {
                        invalidityList.length > 0
                        &&
                        <div className={styles['table-box']}>
                          <div className={styles['table-head']}>
                            <div className={styles['table-title']}>
                              <ExclamationCircleFilled style={{ color: '#FAAD14' }} />
                              <div className={styles["title"]}>Sorry, this item has sold out</div>
                            </div>
                            <div>
                              <HoverIconSwitch
                                IconOne={<DeleteIcon className={styles['cart-icon']} onClick={betchDeleteAvailablelist} />}
                                IconTwo={<DeleteHover className={styles['cart-icon']} onClick={betchDeleteAvailablelist} />}
                                hoverContent="Delete"
                              />
                              <HoverIconSwitch
                                IconOne={<WishListIcon className={styles['cart-icon']} onClick={betchAddWishunAvailablelist} />}
                                IconTwo={<WishListHover className={styles['cart-icon']} onClick={betchAddWishunAvailablelist} />}
                                hoverContent="Move to wishlist"
                              />
                            </div>
                          </div>
                          <div style={{ paddingLeft: 32 }}>
                            <Table
                              dataSource={invalidityList}
                              rowKey="productID"
                              columns={setColumns({ disabled: true })}
                              // loading={loading}
                              pagination={false}
                              showHeader={false}
                            />
                          </div>
                        </div>
                      }
                      <div className={styles["payment-box"]}>
                        <div>

                          {/* postcode与sub选择 */}
                          <div className={styles['postcode-box']}>
                            <div className={styles['postcodeTitle']}>
                              <span>This quotation is based on:</span>
                              <div style={{ width: 200, margin: '0 4px' }}>
                                <SuburbSelect value={suburbId} onChange={suburbChange} notAutoSelect={true} />
                              </div>
                              <span>Enter and Choose Your Suburb to recalculate the Postage</span>
                            </div>
                          </div>
                          {
                            !isUleeId
                            &&
                            <div className={styles['coupon-box']}>
                              <div className={styles['coupon-box-head']}>
                                <div className={styles['coupon-title']} onClick={() => { setShowCoupon(!showCoupon) }} style={{ borderBottom: showCoupon ? "none" : '1px solid #c7c7c7' }}>
                                  Optional Discount and Coupon&nbsp;&nbsp;<DownOutlined />
                                </div>
                                {
                                  !!(!isLogin && showCoupon)
                                  &&
                                  <Button className={styles['signIn-btn']} href="/login?redirect=/viewcart" type="link">Sign In</Button>
                                }
                              </div>

                              <div className={`${styles['collapsible']} ${showCoupon && styles['open']}`}>
                                <div className={styles['coupon-area']}>
                                  <div className={styles['couponItem']}>
                                    <div className={styles['couponItem-label']}>
                                      <p>Total <span className={styles['num']}>{credits}</span> Credits<br />I want to use</p>
                                      {/* {
                                    !isLogin
                                    &&
                                    <Button type="link" href="/login?redirect=/viewcart" className={styles['btn']}>Sign in</Button>
                                  } */}
                                    </div>
                                    <InputNumber
                                      value={creditsInput}
                                      onChange={(val: any) => { 
                                        // 只允许正整数，不允许小数点和负数
                                        if (val === null || val === undefined) {
                                          setCreditsInput(0);
                                        } else if (Number.isInteger(val) && val >= 0) {
                                          setCreditsInput(val);
                                        }
                                      }}
                                      className={styles['couponItem-input']}
                                      placeholder={!isLogin ? 'please sign in to check your credits' : ''}
                                      style={{ width: "100%" }}
                                      controls={false}
                                      min={0}
                                      precision={0}
                                      step={1}
                                    />
                                  </div>

                                  {/* 线 */}
                                  <div className={styles['line']}></div>
                                  {/* 线 */}

                                  <div className={styles['couponItem']}>
                                    <div className={styles['couponItem-label']}>
                                      <p>Total <span className={styles['num']}>{points}</span> BestDealsPoints<br />I want to use</p>
                                      {/* {
                                    !isLogin
                                    &&
                                    <Button type="link" href="/login?redirect=/viewcart" className={styles['btn']}>Sign in</Button>
                                  } */}
                                    </div>
                                    <InputNumber
                                      value={pointsInput}
                                      onChange={(val: any) => { 
                                        // 只允许正整数，不允许小数点和负数
                                        if (val === null || val === undefined) {
                                          setPointsInput(0);
                                        } else if (Number.isInteger(val) && val >= 0) {
                                          setPointsInput(val);
                                        }
                                      }}
                                      className={styles['couponItem-input']}
                                      placeholder={!isLogin ? 'please sign in to check your points' : ''}
                                      style={{ width: "100%" }}
                                      controls={false}
                                      min={0}
                                      precision={0}
                                      step={1}
                                    />
                                  </div>

                                  {/* 线 */}
                                  <div className={styles['line']}></div>
                                  {/* 线 */}

                                  <div className={styles['couponItem']}>
                                    <div className={styles['couponItem-label']}>
                                      Apply Your Coupon:
                                    </div>
                                    <div className={styles['coupon-input-box']}>
                                      <Input
                                        className={styles['couponItem-input']}
                                        placeholder="coupon code"
                                        value={coupon}
                                        onChange={(event: any) => { couponInputChange(event.target.value) }}
                                        onFocus={() => { setInputFocus(true) }} onBlur={() => {
                                          setTimeout(() => {
                                            setInputFocus(false)
                                          }, 150);
                                        }}
                                      />
                                      {/* <Select
                                        value={couponPackage}
                                        className={styles['couponItem-select']}
                                        options={packagesList}
                                        onChange={(couponPackageId: number, option: any) => { slectCoupons(couponPackageId, option) }}
                                        open={inputFocus}
                                        fieldNames={{ label: 'name', value: 'id' }}

                                      /> */}
                                      {/* <div className={`${styles['input-hover']}`} style={{ display: inputFocus ? "block" : "none" }}>
                                  {
                                    packagesList.map((item: any) => (
                                      <div className={styles['input-hover-selectItem']} onClick={slectCoupons.bind(item, item)} key={item.id}>{item.name}</div>
                                    ))
                                  }
                                </div> */}
                                    </div>
                                    <Button className={styles['apply-btn']} onClick={applyDiscount} loading={applyBtnLoading}>Apply Discount</Button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          }



                        </div>
                        <div className={styles['price-box']}>
                          <div className={styles['price-line']}>
                            <div className={styles['priceLabel']}>Sub Total:</div>
                            <div className={styles['priceValue']}>{formatCurrency(paymentInfo.subTotal || 0)}</div>
                          </div>
                          <div className={styles['price-line']}>
                            <div className={styles['priceLabel']}>Shipping:</div>
                            <div className={styles['priceValue']}>{paymentInfo.shippingError > 0 ? 'N/A' : formatCurrency(paymentInfo.shipping || 0)}</div>
                          </div>
                          {
                            discountInfo.couponDiscountValue > 0
                            &&
                            <div className={styles['price-line']}>
                              <div className={styles['priceLabel']}>Coupon:</div>
                              <div className={styles['priceValue']}>-{formatCurrency(discountInfo.couponDiscountValue || 0)}</div>
                            </div>
                          }
                          {
                            discountInfo.credits > 0
                            &&
                            <div className={styles['price-line']}>
                              <div className={styles['priceLabel']}>Credits:</div>
                              <div className={styles['priceValue']}>-{formatCurrency(discountInfo.credits || 0)}</div>
                            </div>
                          }
                          {
                            discountInfo.pointsValue > 0
                            &&
                            <div className={styles['price-line']}>
                              <div className={styles['priceLabel']}>BestDealsPoints:</div>
                              <div className={styles['priceValue']}>-{formatCurrency(discountInfo.pointsValue || 0)}</div>
                            </div>
                          }

                          <div className={styles['price-line']}>
                            <div className={`${styles['priceLabel']} ${styles['bold']}`}>Total Amount:</div>
                            <div className={`${styles['priceValue']} ${styles['bold']}`}>{formatCurrency(paymentInfo.total || 0)}</div>
                          </div>
                        </div>
                      </div>

                      <div
                        className={styles['payment-select']}
                        style={{ marginTop: showSaveCart ? '100px' : '12px' }}
                        id="payment-select"
                      >
                        <Button
                          className={styles["payment-btn"]}
                          type="primary"
                          href="/"
                          ghost
                        >Continue Shopping</Button>

                        <Button
                          className={`${styles["payment-btn"]} ${styles["paypal-btn"]}`}
                          type="primary"
                          onClick={() => { checkoutEvent(() => { handleOpenPaypal() }) }}
                        >
                          <Row align="middle">
                            <div style={{ width: 80, height: 26 }} >
                              <PaypalCheckoutSvg style={{ width: 80, height: "100%" }} />
                            </div>
                            <div style={{ marginLeft: "12px" }}>Checkout</div>
                          </Row>
                        </Button>

                        {
                          !!(!isUleeId && (paymentInfo.total || 1) <= 4000)
                          &&
                          <>
                            <span className={styles['or']}>OR</span>
                            {
                              !selectedRowKeys.length
                                ?
                                // <Button
                                //   className={`${styles["payment-btn"]} ${styles["afterpay-btn"]}`}
                                //   onClick={() => { checkoutEvent() }}
                                //   type="primary"
                                // >
                                //   <Image
                                //     src={'https://img.bestdeals.co.nz/images/2022v/img/public/icon-Checkout-afterpay-color.svg'}
                                //     width={233}
                                //     height={40}
                                //     preview={false}
                                //   />
                                // </Button>
                                <AfterpayCheckoutSvg
                                  style={{ cursor: 'pointer', width: 233, height: 40 }}
                                  onClick={() => { checkoutEvent() }}
                                />
                                :
                                <Button
                                  className={`${styles["payment-btn"]} ${styles["afterpay-btn"]}`}
                                  type="primary"
                                  id="afterpayBtn"
                                >
                                  <AfterpayCheckoutSvg
                                    style={{ cursor: 'pointer', width: 233, height: 40 }}
                                  />
                                </Button>
                            }

                          </>
                        }
                        <span className={styles['or']}>OR</span>
                        <Popover
                          placement="topRight"
                          content={saveCartEle}
                          open={showSaveCart}
                          color="#FF9F01"
                          overlayInnerStyle={{ width: '350px' }}
                          getPopupContainer={(triggerNode: any) => {
                            const container = document.getElementById('checkout-btn-bottom');
                            return container ? container : triggerNode.parentElement; // 确保返回一个非空的 HTMLElement
                          }}>
                          <Button id="checkout-btn-bottom" className={styles["payment-btn"]} type="primary" onClick={() => { checkoutEvent(() => { window.location.href = '/checkout' }) }} >Checkout</Button>
                        </Popover>
                      </div>

                      <div className={styles['viewcar-footer']}>
                        <div className={styles["left"]}>
                          <div className={styles['title']}>
                            We Proudly Accept:
                          </div>
                          {paymentLogoItem}
                          <div className={styles['payment-privacy']}>
                            <Image src={`${imageDomain}/checkout/norton.png`} height="48px" preview={false} />
                            <Image src={`${imageDomain}/checkout/compdp.png`} height="48px" preview={false} />
                            <Image src={`${imageDomain}/checkout/lock.png`} height="48px" preview={false} />
                            <div className={styles['privacy']}>
                              Your payment details are protected and
                              encrypted by 256-bit SSL technology.
                              Your privacy and security is guaranteed.
                            </div>
                          </div>
                        </div>

                        <div className={styles['recommend-goods']}>
                          {
                            topsaleList.map((item: any) => (
                              // <div className={styles['goodsItem']} key={item.productID}>
                              //   <div className={styles['goodsImg']}>
                              //     <Image width="100%" src={item.filename} preview={false} />
                              //   </div>
                              //   <div className={styles['goodsPrice']}>${item.price}</div>
                              //   <Button onClick={addTopSaleCart.bind(item, item)} type="primary" className={styles['goodsAddcart']} >Add to Cart</Button>
                              // </div>
                              <TopSaleViewcarGoodsComponent key={item.productID} {...item} successAddCart={successAddCart} />
                            ))
                          }
                        </div>

                      </div>
                    </div>
                    :
                    <EmptyCart />
              }

              <Recommend type="wishilist" successAddCart={successAddCart} isLogin={isLogin} />
              <Recommend type="related" list={effectiveList} successAddCart={successAddCart} />
            </div>

            <Modal
              title="Delete Item"
              open={isModalOpen}
              centered
              onOk={deleteCart}
              onCancel={() => { setIsModalOpen(false) }}
              okText="Yes"
              cancelText="No"
              confirmLoading={deleteLoading}
            >
              <div>
                {
                  deleteArray.length > 1 ?
                    'Are you sure you want to delete the selected items？'
                    :
                    'Are you sure you want to delete the selected items？'
                }
              </div>
            </Modal>
          </div >
        </Spin>
      </CheckoutLayout>
    </>
  )
}

interface MySelectProps {
  maxNumber: number;
  qtyChange: any;
  disabled: boolean;
  quantity: number;
  moreThen: boolean;
}

const { Option } = Select;

const MySelect = ({ maxNumber, qtyChange, disabled, quantity, moreThen }: MySelectProps) => {
  // 生成从 0 到 maxNumber 的数组
  const options = Array.from({ length: maxNumber + 1 }, (_, i) => ({
    value: i.toString(), // 将数字转换为字符串
    label: i == 0 ? `${i}(Delete)` : (i == maxNumber && moreThen) ? '100(Max)' : i.toString(),
  }));

  return (
    <Select value={quantity} placeholder="Select a number" style={{ width: "100%" }} onChange={qtyChange} disabled={disabled} >
      {options.map(option => (
        <Option key={option.value} value={option.value}>
          {option.label}
        </Option>
      ))}
    </Select>
  );
};

const EmptyCart = () => {
  return (
    <div className={styles['empty-cart']}>
      <div className={styles['empty-cart-main']}>
        <div className={styles['empty-cart-head']}>
          <h1>Shopping Cart</h1>
          <Button href="/" className={styles['empty-cart-btn']}>CONTINUE SHOPPING</Button>
        </div>
        <Image src={`https://img.bestdeals.co.nz/images/viewcar/Cart%20ls%20Empty.png`} width="280px" preview={false} />
        <div className={styles['empty-cart-title']}>Your Shopping cart Is Empty! </div>
        <div className={styles['empty-cart-desc']}>{`Add products to your cart by clicking the 'Add to Cart' button next`}<br />{`to the items you would like to purchase.`}</div>
        <div className={styles['question-help']}>
          <div className={styles['question-title']}>Questions About Your Order?</div>
          <div className={styles['question-desc']}>Please feel free to <Link href={'/contact-us'} legacyBehavior><a rel="noopener noreferrer">contact us</a></Link>. Our customer service team will help you.</div>
        </div>
      </div>
    </div>
  )
}

const Recommend = ({ type, list, successAddCart, isLogin }: any) => {

  const swiper: any = useRef(null);

  const [recommendList, setRecommendList] = useState<any>([]);
  const [isFirst, setIsFirst] = useState(true)

  const getRecommend = async () => {
    try {
      const params = type == 'related' ? { items: list.map((item: any) => ({ productID: item.productID, categoryID: item.categoryID })) } : {}
      const apiFunction = type == 'related' ? viewcartApi.related : myAccountApi.getWishList;
      const res = await apiFunction(params)
      setRecommendList(type == 'related' ? res.data.pageList.items : res.data.wishProducts.filter((v: any) => v.inStock > 0));
      if (type == 'related' && res.data.pageList.items.length > 0) {
        setIsFirst(false);
      }
    } catch (error: any) {
      // message.error(error.message);
    }
  }

  useEffect(() => {
    // 心愿单没登录不获取接口
    if (!isLogin && type == 'wishilist') return;

    if (isFirst) {
      getRecommend()
    }
  }, [isLogin, list])

  return (
    recommendList.length
      ?
      <div className={styles['recomment-box']}>
        <div className={styles['recomment-title']}>
          <div>{type == 'wishilist' ? 'Your Wish List:' : 'Customer Who Bought These Products Also Bought:'}</div>
          <div className={styles['page-control']}>
            <LeftOutlined className={styles['control-icon']} onClick={() => { swiper.current.slidePrev() }} />
            <RightOutlined className={styles['control-icon']} onClick={() => { swiper.current.slideNext() }} />
          </div>
        </div>
        <div className={styles['recomment-list']}>
          <SwiperSelf
            slidesPerView={5}
            autoplay={false}
            hideArrows={true}
            spaceBetween={10}
            ref={swiper}
          >
            {
              recommendList.map((item: any) => (
                <SwiperSlide key={item.productID}>
                  <ViewcarGoodsComponent {...item} successAddCart={successAddCart} />
                </SwiperSlide>
              ))
            }
          </SwiperSelf>
        </div>
      </div>
      :
      <></>
  )
}

const ViewcarGoodsComponent = ({ filename, url, name, price, normalPrice, productID, successAddCart, preSales }: any) => {
  const { addToCart } = useCartActions();
  const addToCartCallBack = (response: any) => {
    if (response != "error") {
      successAddCart(response)
      message.success("Add to cart successfully!")
    }
    setLoadingBtn(false);
  }

  const [loadingBtn, setLoadingBtn] = useState(false);

  const addCart = (event: any) => {
    setLoadingBtn(true);
    addToCart(event, { productID, qty: 1 }, addToCartCallBack)
  }

  const preOrder = () => {
    window.location.href = '/checkout?p=' + productID + '&t=1';
  }

  const priceArr = `${price}`.split('.');
  return (
    <div className={styles['viewcar-component']}>
      <Link href={url} legacyBehavior>
        <a rel="noopener noreferrer" style={{width: '100%',display:'block', aspectRatio: '1 / 1',overflow: 'hidden'}}>
          <Image
            src={getCompressedImageUrl(filename, 227)}
            preview={false}
            width="100%"
            height="100%"
            style={{objectFit: "contain"}}
          />
        </a>
      </Link>
      <Link href={url} legacyBehavior>
        <a rel="noopener noreferrer" className={styles['goods-name']}>
          {name}
        </a>
      </Link>
      <div className={styles['price-line']}>
        <div className={styles['price']}>${priceArr[0]}.<span>{priceArr[1]}</span></div>
        {
          (normalPrice && normalPrice != price)
          &&
          <div className={styles['cross-price']}>{formatCurrency(normalPrice)}</div>
        }
      </div>
      {
        preSales
          ?
          <Button className={styles['pre_order_btn']} onClick={preOrder} loading={loadingBtn} >PRE-ORDER</Button>
          :
          <Button loading={loadingBtn} type="primary" className={styles['addcart-btn']} onClick={addCart} >Add to Cart</Button>
      }
    </div>
  )
}

const TopSaleViewcarGoodsComponent = ({ productID, filename, price, url, successAddCart }: any) => {
  const { addToCart } = useCartActions();

  const [loading, setLoading] = useState(false);
  const addToCartCallBack = (response: any) => {
    setLoading(false);
    if (response != "error") {
      successAddCart(response)
      message.success("Add to cart successfully!")
    }
  }
  const addCart = (event: any) => {
    setLoading(true);
    addToCart(event, { productID: productID, qty: 1 }, addToCartCallBack)
  }
  return (
    <div className={styles['goodsItem']}>
      <Link href={url} legacyBehavior>
        <a rel="noopener noreferrer" className={styles['goodsImg']}>
          <Image width="100%" src={getCompressedImageUrl(filename, 112)} preview={false} />
        </a>
      </Link>
      <div className={styles['goodsPrice']}>{formatCurrency(price)}</div>
      <Button onClick={addCart} loading={loading} type="primary" className={styles['goodsAddcart']} >Add to Cart</Button>
    </div>
  )
}